
console.log('top-10.js运行了!!!!')


function initSwiper() {
document.querySelectorAll('.case-swiper').forEach((el) => {
    
    const shell = el.closest('.carousel-shell');

    new Swiper(el, {
      spaceBetween: 16,
      speed: 500,
      loop: true,
      grabCursor: true,

      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      }

      ,

      navigation: {
        nextEl: shell.querySelector('.swiper-button-next'),
        prevEl: shell.querySelector('.swiper-button-prev'),
      }

      ,
    });
  });
}

// 等文章富文本渲染完再初始化
window.addEventListener('load', () => {
  setTimeout(initSwiper, 50); // 延迟 50ms 保证 DOM 已生成
});
